<template>
  <div class="container" :class="{ hideborder: hideborder }">
    <div class="title">{{ title }}</div>
    <div><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: ["title", "hideborder"],
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
  padding: 7px 10px;
}
.hideborder {
  border-bottom-width: 0px;
}
.title {
  color: #7b7b7b;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  width: max-content;
}
</style>
